export default __webpack_public_path__ + "static/media/kitchen3-afterF-2048w.4ce8cb6d.png";